var React = require('react');

function Eye (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 3C4 3 1.66667 6.66667 1 8C1.66667 9.33333 4 13 8 13C12 13 14.3333 9.33333 15 8C14.3333 6.66667 12 3 8 3Z","stroke":"currentColor","key":0}),React.createElement("circle",{"cx":"8","cy":"8","r":"2.5","stroke":"currentColor","key":1})]);
}

Eye.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Eye;

Eye.default = Eye;
